import React, { useContext } from "react";
import FormCard from "../../../components/FormCard";
import PillButton from "../../../components/PillButton";
import { APIContext } from "../../../connector";
import logo from "../../../static/images/Logo.png";
import ig from "../../../static/images/instagram.png";
import classes from "./Comingsoon.module.scss";

const Comingsoon = () => {
  const { logout } = useContext(APIContext);
  return (
    <div className={classes.comingsoonWrapper}>
      <img src={logo} alt="Logo" className={classes.logo} />
      <FormCard>
        <h1 className={classes.comingsoonTitle}>
          Thank you for registering !
        </h1>

        <p className={classes.banner}>
          Welcome to the ONLY closed-community ride-sharing platform 💛
        </p>
        <p className={classes.comingsoon}>Coming Soon! 🚀</p>
        <p className={classes.comingsoonText}>
          A simpler way to get around campus. Stay updated for our launch.
        </p>
        <div className={classes.footer}>
          <img src={ig} alt="Instagram" className={classes.instagram} />{" "}
          <span>@sapu_my</span>
        </div>
         <PillButton
          className={`${classes.logoutButton} rejectButton`}
          onClick={logout}
        >
          Logout
        </PillButton>
      </FormCard>
    </div>
  );
};

export default Comingsoon;
